import Image from 'next/image';

export default function Hero({
    heading = 'working',
    caption = 'working',
    buttonText,
    buttonLink,
    image = '/images/team.jpg',
    showShadowOnImage = true,
    width = 'w-1/2',
}) {
    return (
        <div id="page-1" className="bg-opacity-80 pb-12 md:pb-16">
            {/* Mobile Image */}
            <Image
                width={1000}
                height={100}
                src={image}
                alt={heading}
                className="md:hidden mt-6 w-[70%] mx-auto"
                id="top-image"
            />

            <div id="content" className="mt-4">
                <div className="w-full flex flex-col md:flex-row mt-[-2vw] md:mt-0">
                    {/* LEFT CONTENT */}
                    <div
                        id="left"
                        className={`px-6 pt-6 md:${width} md:px-12 md:pt-20 md:ml-10`}
                    >
                        <h1 className="text-2xl md:text-5xl font-bold mt-4 text-gray-800">
                            {heading}
                        </h1>

                        <p className="my-3 md:my-4 text-gray-600 text-base md:text-lg font-semibold">
                            {caption}
                        </p>

                        {buttonLink && buttonText && (
                            <a href={buttonLink}>
                                <button className="hello_button py-3 px-10 md:py-2 md:px-8 bg-blue-500 rounded-md mt-4 shadow-xl hover:shadow-none transition duration-300">
                                    <span className="font-bold text-white text-sm md:text-base">
                                        {buttonText}
                                    </span>
                                </button>
                            </a>
                        )}
                    </div>

                    {/* DESKTOP IMAGE */}
                    <div className="hidden md:block self-end">
                        <Image
                            src={image}
                            alt={heading}
                            width={3000}
                            height={3000}
                            className={`w-[60%] mx-auto rounded-lg ${
                                showShadowOnImage ? 'shadow-xl' : ''
                            } transition-transform duration-200 hover:scale-105`}
                            id="bottom"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
